export const US_STATES = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "DC", name: "District of Columbia" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
];

export const BUNDLE_CODES = [
  "CAP1",
  "CAP1A",
  "CAP1B",
  "CAP2",
  "CAP2A",
  "CAP2B",
  "CAP3",
  "AUD1",
  "AUD2",
];

export const AUDIOLOGIST_SKU_OPTIONS = [
  { code: "CAP1", label: "Captify Pro", price: 699 },
  { code: "CAP3", label: "Captify Myvu", price: 499 },
];

export const AUDIOLOGIST_BUNDLE_OPTIONS = [
  {
    code: "AUD1",
    accessories: "Charger, Sunglasses Clip-on (Black and Brown)",
    handheld: "Included",
  },
  {
    code: "AUD2",
    accessories: "Charger, Sunglasses Clip-on (Black and Brown)",
    handheld: "Included",
  },
];

export const AUDIOLOGIST_PRESCRIPTION_TYPE_OPTIONS = [
  {
    value: "I Don't Need Prescription Lenses",
    label: "I Don't Need Prescription Lenses",
    description:
      "Select this option for standard, non-prescription lenses without vision correction.",
  },
  {
    value: "Single vision",
    label: "Single Vision",
    description:
      "These lenses correct either nearsightedness, farsightedness, or astigmatism, offering clear vision at a single distance.",
  },
  {
    value: "Reading Lenses",
    label: "Reading Lenses",
    description:
      "Designed for close-up tasks, these lenses enhance clarity for reading, screens, or other near-vision needs.",
  },
  {
    value: "Progressive Lenses",
    label: "Progressive Lenses",
    description:
      "A better alternative to bi-focals, these lenses provide seamless correction for near, intermediate, and distance vision without visible lines.",
  },
  {
    value: "Bifocal Lenses",
    label: "Bifocal Lenses",
    description:
      "These lenses have two distinct viewing zones—one for distance and one for near—making it easy to switch between seeing far and reading up close.",
  },
];

export const AUDIOLOGIST_LENS_TYPE_OPTIONS = [
  {
    value: "Clear Lenses",
    label: "Clear Lenses",
    priceExtra: 0,
    description:
      "Polycarbonate lenses with anti-scratch coating for everyday clarity.",
  },
  {
    value: "Blue Light Filtering Lenses",
    label: "Blue Light Filtering",
    priceExtra: 100,
    description:
      "Filters blue light from screens and reduces eye strain during extended use.",
  },
];

export const AUDIOLOGIST_INDEX_OPTIONS = [
  {
    value: "1.60",
    label: "1.60 High-Index",
    priceExtra: 0,
    description:
      "Thinner and lighter than standard lenses, ideal for moderate prescriptions.",
  },
  {
    value: "1.67",
    label: "1.67 Ultra-High Index",
    priceExtra: 100,
    description:
      "Even thinner lenses for stronger prescriptions without extra bulk.",
  },
  {
    value: "1.74",
    label: "1.74 Ultra-High Index",
    priceExtra: 200,
    description:
      "The thinnest and lightest option available for the strongest prescriptions.",
  },
];

export const AUDIOLOGIST_MOUNTING_OPTIONS = [
  {
    value: "inserts",
    label: "Insert",
    priceExtra: 0,
    description:
      "A removable frame that holds your prescription lenses onto the Captify frames.",
  },
  {
    value: "bonded",
    label: "Bonded",
    priceExtra: 50,
    description:
      "Your prescription lenses are bonded to the waveguide displays for a seamless look.",
  },
];

export const MOCK_AUDIOLOGIST_PAYMENT_METHOD = {
  brand: "Visa",
  last4: "3456",
};

export const AUDIOLOGIST_LENS_OPTIONS = {
  lensTypes: AUDIOLOGIST_LENS_TYPE_OPTIONS.map(({ value, label }) => ({
    value,
    label,
  })),
  indexTypes: AUDIOLOGIST_INDEX_OPTIONS.map(({ value, label }) => ({
    value,
    label,
  })),
  mountingTypes: AUDIOLOGIST_MOUNTING_OPTIONS.map(({ value, label }) => ({
    value,
    label,
  })),
};

export const BUNDLE_BREAKDOWNS = {
  CAP1: {
    glasses: "Captify Pro",
    accessories: "Charger, Sunglasses Clip-on (Black and Brown)",
    handheld: "Included",
    lenses: "None",
  },
  CAP1A: {
    glasses: "Captify Pro",
    accessories: "Charger, Sunglasses Clip-on (Black and Brown)",
    handheld: "Included",
    lenses: "BLF - Progressive - 1.74 - Bonded",
  },
  CAP1B: {
    glasses: "Captify Pro",
    accessories: "Charger, Sunglasses Clip-on (Black and Brown)",
    handheld: "Included",
    lenses: "BLP - Progressive - 1.74 - Bonded",
  },
  CAP2: {
    glasses: "Captify Pro",
    accessories: "Charger",
    handheld: "Not included",
    lenses: "None",
  },
  CAP2A: {
    glasses: "Captify Pro",
    accessories: "Charger",
    handheld: "Not included",
    lenses: "BLF - Single Vision - 1.60 - Bonded",
  },
  CAP2B: {
    glasses: "Captify Pro",
    accessories: "Charger",
    handheld: "Not included",
    lenses: "BLP - Single Vision - 1.60 - Bonded",
  },
  CAP3: {
    glasses: "Captify Myvu",
    accessories: "Charger",
    handheld: "Included",
    lenses: "None",
  },
  AUD1: {
    glasses: "Captify Pro",
    accessories: "Charger, Sunglasses Clip-on (Black and Brown)",
    handheld: "Included",
    lenses: "None",
  },
  AUD2: {
    glasses: "Captify Pro",
    accessories: "Charger, Sunglasses Clip-on (Black and Brown)",
    handheld: "Included",
    lenses: "None",
  },
};

export function getAudiologistBundleBreakdown(bundleCode, skuCode, skuLabel) {
  const bundle = AUDIOLOGIST_BUNDLE_OPTIONS.find((item) => item.code === bundleCode);
  const sku = AUDIOLOGIST_SKU_OPTIONS.find((item) => item.code === skuCode);
  const fallback = BUNDLE_BREAKDOWNS[bundleCode] || BUNDLE_BREAKDOWNS.AUD1;

  return {
    glasses:
      String(skuLabel || "").trim() ||
      sku?.label ||
      fallback.glasses,
    accessories: bundle?.accessories || fallback.accessories,
    handheld: bundle?.handheld || fallback.handheld,
    lenses: fallback.lenses || "None",
  };
}

/** Create Order: prescription UI only for lens variants (not CAP1 / CAP2 base). */
export function bundleRequiresPrescription(code) {
  const normalized = String(code || "")
    .trim()
    .toUpperCase()
    .replace(/[\s_-]+/g, "");
  return (
    normalized === "CAP1A" ||
    normalized === "CAP1B" ||
    normalized === "CAP2A" ||
    normalized === "CAP2B"
  );
}

export function formatTerritory(stateCode) {
  const state = US_STATES.find((s) => s.code === stateCode);
  return state ? `${state.name} (${state.code})` : stateCode;
}

export const MOCK_COMMISSIONS = [
  { id: "comm-10", label: "10%" },
  { id: "comm-12", label: "12%" },
  { id: "comm-15", label: "15%" },
];

export const MOCK_DISTRIBUTOR_CANDIDATES = [
  {
    id: "cand-1",
    name: "Faith Seyler",
    email: "faithseyler@captify.glass",
    territories: ["CA"],
  },
  { id: "cand-2", name: "Cami Ayala", email: "camiayala@captify.glass" },
  { id: "cand-3", name: "Casey Altenberg", email: "caseyaltenberg@captify.glass" },
  { id: "cand-4", name: "Joe Doyle", email: "jodoyle@captify.glass" },
  
];

let mockDistributorsDb = [
  {
    id: "dist-1",
    name: "Faith Seyler",
    email: "faithseyler@captify.glass",
    phone: "",
    territories: ["CA", "NV"],
    commission: { id: "comm-10", label: "10%" },
    cardNumber: "1234 5678 9012 3456",
    routingNumber: "123",
    isActive: true,
    ordersCount: 156,
    totalAmount: 945200,
  },
  {
    id: "dist-2",
    name: "Cam Ayala",
    email: "camayala@captify.glass",
    territories: ["NY", "WA"],
    commission: { id: "comm-12", label: "12%" },
    isActive: true,
    ordersCount: 23,
    totalAmount: 828590,
  },
  {
    id: "dist-3",
    name: "Carey Altenberg",
    email: "careyaltenberg@captify.glass",
    territories: ["AK"],
    commission: { id: "comm-10", label: "10%" },
    isActive: true,
    ordersCount: 872,
    totalAmount: 1124602,
  },
  {
    id: "dist-4",
    name: "Joe Doyle",
    email: "jodoyle@captify.glass",
    territories: ["NY", "WA"],
    commission: { id: "comm-15", label: "15%" },
    isActive: true,
    ordersCount: 412,
    totalAmount: 756340,
  },
  {
    id: "dist-5",
    name: "Rich",
    email: "rich@captify.glass",
    territories: ["FL"],
    commission: { id: "comm-10", label: "10%" },
    isActive: true,
    ordersCount: 198,
    totalAmount: 621880,
  },
];

const MOCK_DISTRIBUTOR_SEED = [
  { name: "Cami Ayala", email: "camiayala@captify.glass", territories: ["TX"], ordersCount: 67, totalAmount: 534210 },
  { name: "Casey Altenberg", email: "caseyaltenberg@captify.glass", territories: ["CA"], ordersCount: 301, totalAmount: 891450 },
  { name: "Jordan Miles", email: "jordanmiles@captify.glass", territories: ["NV"], ordersCount: 44, totalAmount: 402150 },
  { name: "Taylor Brooks", email: "taylorbrooks@captify.glass", territories: ["FL", "TX"], ordersCount: 529, totalAmount: 998320 },
  { name: "Morgan Reed", email: "morganreed@captify.glass", territories: ["WA"], ordersCount: 118, totalAmount: 712600 },
  { name: "Alex Chen", email: "alexchen@captify.glass", territories: ["CA", "NV"], ordersCount: 245, totalAmount: 865900 },
  { name: "Sam Rivera", email: "samrivera@captify.glass", territories: ["NY"], ordersCount: 91, totalAmount: 478200 },
  { name: "Jamie Fox", email: "jamiefox@captify.glass", territories: ["AK", "WA"], ordersCount: 63, totalAmount: 389750 },
  { name: "Riley Park", email: "rileypark@captify.glass", territories: ["TX"], ordersCount: 334, totalAmount: 921100 },
  { name: "Dana Walsh", email: "danawalsh@captify.glass", territories: ["FL"], ordersCount: 177, totalAmount: 654300 },
];

while (mockDistributorsDb.length < 51) {
  const seed = MOCK_DISTRIBUTOR_SEED[(mockDistributorsDb.length - 5) % MOCK_DISTRIBUTOR_SEED.length];
  const n = mockDistributorsDb.length + 1;
  mockDistributorsDb.push({
    id: `dist-${n}`,
    name: n > 14 ? `${seed.name} ${n}` : seed.name,
    email: n > 14 ? seed.email.replace("@", `${n}@`) : seed.email,
    territories: seed.territories,
    commission: MOCK_COMMISSIONS[n % MOCK_COMMISSIONS.length],
    isActive: true,
    ordersCount: seed.ordersCount + (n % 7) * 3,
    totalAmount: seed.totalAmount + (n % 11) * 12500,
  });
}

export function getMockDistributors() {
  return [...mockDistributorsDb];
}

export function setMockDistributors(list) {
  mockDistributorsDb = list;
}

export const MOCK_DISTRIBUTOR_OPTIONS = [
  { id: "dist-5", name: "Rich", territory: "Florida (FL)" },
  { id: "dist-1", name: "Faith Seyler", territory: "California (CA)" },
  { id: "dist-2", name: "Cami Ayala", territory: "Texas (TX)" },
];

export function createMockParseResult() {
  const parseId = `temp-${crypto.randomUUID?.() || Date.now()}`;
  return {
    parseId,
    bundle: {
      code: "CAP1",
      label: "CAP1",
      items: [
        { type: "glasses", label: "Captify Pro" },
        { type: "accessories", label: "Charger, Sunglasses Clip-on (Black and Brown)" },
        { type: "handheld", label: "Included" },
        { type: "lenses", label: "None" },
      ],
    },
    distributor: {
      id: "dist-5",
      name: "Rich",
      territory: "Florida (FL)",
      suggested: true,
    },
    distributorOptions: MOCK_DISTRIBUTOR_OPTIONS,
    prescription: {
      od: { sph: "", cyl: "", axis: "", add: "", pd: "" },
      os: { sph: "", cyl: "", axis: "", add: "", pd: "" },
      pdType: "Two",
      fileUrl: null,
    },
    delivery: {
      firstName: "James",
      lastName: "A.",
      clinicName: "Dr Ersoff in Audiology",
      hospitalName: "James A. Haley Veterans Hospital",
      address1: "13000 Bruce B. Downs BLVD",
      address2: "",
      city: "Tampa",
      state: "FL",
      zip: "33612",
      phone: "+1 603-722-1234",
      email: "jamesA@email.com",
    },
    invoiceMeta: {
      poNumber: "673-6S4175",
      requisitioner: "Frederick Cowans",
    },
  };
}

const PARSE_STORAGE_KEY = "va_parse_results";

export function saveParseResult(parseId, data) {
  if (!parseId || !data) return;
  const all = JSON.parse(sessionStorage.getItem(PARSE_STORAGE_KEY) || "{}");
  all[parseId] = data;
  sessionStorage.setItem(PARSE_STORAGE_KEY, JSON.stringify(all));
}

export function getParseResult(parseId) {
  if (!parseId) return null;
  const all = JSON.parse(sessionStorage.getItem(PARSE_STORAGE_KEY) || "{}");
  return all[parseId] || null;
}

export const MOCK_DISTRIBUTOR_METRICS = {
  last_month: {
    period: "last_month",
    totalRevenue: 148520,
    totalCommission: 32784.4,
    pendingPayout: 6240,
    paidOut: 26544.4,
    returnsDeduction: -1184.6,
    unitsSold: 612,
    ordersReceived: 612,
    ordersShipped: 540,
  },
  this_month: {
    period: "this_month",
    totalRevenue: 42380,
    totalCommission: 9342.5,
    pendingPayout: 2100,
    paidOut: 8920,
    returnsDeduction: -320,
    unitsSold: 178,
    ordersReceived: 178,
    ordersShipped: 142,
  },
  last_3_months: {
    period: "last_3_months",
    totalRevenue: 412600,
    totalCommission: 91240,
    pendingPayout: 6240,
    paidOut: 78400,
    returnsDeduction: -3420,
    unitsSold: 1684,
    ordersReceived: 1684,
    ordersShipped: 1510,
  },
};

const MOCK_AUDIOLOGIST_METRICS = {
  last_month: {
    period: "last_month",
    totalOrders: 284,
    totalSpend: 96840,
    averageOrderValue: 341,
    totalReturns: 11,
    returnsAmount: 3276,
  },
  last_3_months: {
    period: "last_3_months",
    totalOrders: 812,
    totalSpend: 276480,
    averageOrderValue: 338,
    totalReturns: 29,
    returnsAmount: 9840,
  },
};

export function getMockDistributorMetrics(filter = "last_month") {
  const params =
    typeof filter === "string" ? { period: filter } : filter || { period: "last_month" };
  const { period, startDate, endDate } = params;

  if (period === "custom" && startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const days = Math.max(
      1,
      Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1
    );
    const factor = days / 30;
    const base = MOCK_DISTRIBUTOR_METRICS.last_month;
    return {
      period: "custom",
      startDate,
      endDate,
      totalRevenue: Math.round(base.totalRevenue * factor),
      totalCommission: +(base.totalCommission * factor).toFixed(1),
      pendingPayout: +(base.pendingPayout * Math.min(factor, 1)).toFixed(1),
      paidOut: +(base.paidOut * factor).toFixed(1),
      returnsDeduction: +(base.returnsDeduction * factor).toFixed(1),
      unitsSold: Math.round(base.unitsSold * factor),
      ordersReceived: Math.round(base.ordersReceived * factor),
      ordersShipped: Math.round(base.ordersShipped * factor),
    };
  }

  return (
    MOCK_DISTRIBUTOR_METRICS[period] ?? {
      period,
      totalRevenue: 0,
      totalCommission: 0,
      pendingPayout: 0,
      paidOut: 0,
      returnsDeduction: 0,
      unitsSold: 0,
      ordersReceived: 0,
      ordersShipped: 0,
    }
  );
}

export function getMockAudiologistMetrics(filter = "last_month") {
  const params =
    typeof filter === "string" ? { period: filter } : filter || { period: "last_month" };
  const { period, startDate, endDate } = params;

  if (period === "custom" && startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const days = Math.max(
      1,
      Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1
    );
    const factor = days / 30;
    const base = MOCK_AUDIOLOGIST_METRICS.last_month;
    return {
      period: "custom",
      startDate,
      endDate,
      totalOrders: Math.round(base.totalOrders * factor),
      totalSpend: Math.round(base.totalSpend * factor),
      averageOrderValue: Math.round(base.averageOrderValue * (0.95 + factor * 0.05)),
      totalReturns: Math.round(base.totalReturns * factor),
      returnsAmount: Math.round(base.returnsAmount * factor),
    };
  }

  return (
    MOCK_AUDIOLOGIST_METRICS[period] ?? {
      period,
      totalOrders: 0,
      totalSpend: 0,
      averageOrderValue: 0,
      totalReturns: 0,
      returnsAmount: 0,
    }
  );
}

export const delay = (ms = 600) => new Promise((resolve) => setTimeout(resolve, ms));
